import React from 'react';
import { cn } from '../lib/utils';

export interface ProgressProps {
  value: number;
  max?: number;
  label: string;
  valueText?: string;
  className?: string;
}
export function Progress({ value, max = 100, label, valueText, className }: ProgressProps) {
  const limit = Number.isFinite(max) && max > 0 ? max : 100;
  const boundedValue = Number.isFinite(value) ? Math.min(limit, Math.max(0, value)) : 0;
  const text = valueText ?? `${Math.round((boundedValue / limit) * 100)}%`;
  return (
    <div className={cn('min-w-0 space-y-1 font-body text-body', className)}>
      <div className="flex justify-between gap-2">
        <span>{label}</span>
        <span className="tabular-nums">{text}</span>
      </div>
      <div
        role="progressbar"
        aria-label={label}
        aria-valuemin={0}
        aria-valuemax={limit}
        aria-valuenow={boundedValue}
        aria-valuetext={text}
        className="h-2 overflow-hidden rounded-control border border-border bg-surface-soft"
      >
        <div className="h-full bg-action" style={{ width: `${(boundedValue / limit) * 100}%` }} />
      </div>
    </div>
  );
}
